import { createApp } from "vue"
import App from "./App.vue"
import { vMaska } from "maska"
import router from "./router"
import store from "./store"
import "./css/global.css"

createApp(App).use(store).directive("maska", vMaska).use(router).mount("#app")
